const registerProgressAccordion = () => {
  $('.accordion')
    .accordion({
      selector: {
        trigger: '.title'
      }
    });
};

const registerReportInstanceDetail = () => {
  registerProgressAccordion();
};

window.registerReportInstanceDetail = registerReportInstanceDetail;
